// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.
export let VariableTick = function (dataObj)
{
    this.LeftBorder = dataObj.lowLimit || 0
    this.RightBorder = dataObj.highLimit || 0
    this.IncludeLeftBorder = dataObj.allowLimit
    this.PointSize = dataObj.pointSize
    this.TickCost = dataObj.tickCost
}

/// <summary>
/// проверка на вхождение
/// </summary>
VariableTick.prototype.CheckPrice = function (price)
{
    if (isNaN(price))       // если цена NaN - не находит никакой интервал
        price = -1          // пока преобразовываем в -1 для проверки, чтоб было по старой схеме. TODO: подумать над решением лучше

    return (price > this.LeftBorder && price < this.RightBorder)
        || (price == this.LeftBorder && this.IncludeLeftBorder)
        || (price == this.RightBorder && !this.IncludeLeftBorder);
}

VariableTick.prototype.toString = function ()
{
    return this.LeftBorder + ((this.IncludeLeftBorder && this.LeftBorder != Number.POSITIVE_INFINITY) ? "<= " : "< ") + "price"
        + ((!this.IncludeLeftBorder && this.RightBorder != Number.NEGATIVE_INFINITY) ? "<= " : "< ") + this.RightBorder;
}